(() => {
  if (customElements.get('wf-home-certifications')) return;

  class WfHomeCertifications extends HTMLElement {
    connectedCallback() {
      if (this.dataset.countsReady === 'true' || this.loading) return;
      this.loading = true;
      this.controller = new AbortController();
      this.loadCounts(this.controller.signal);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.loading = false;
    }

    async loadCounts(signal) {
      const controller = this.controller;
      const timeout = window.setTimeout(() => controller.abort(), 10000);
      try {
        const url = new URL(this.dataset.countsUrl, window.location.origin);
        if (url.origin !== window.location.origin) return;

        // Keep an unpublished theme preview on the same theme. Do not inherit
        // collection filters, pagination or other homepage query parameters.
        const currentUrl = new URL(window.location.href);
        for (const key of ['preview_theme_id', '_fd', 'pb']) {
          if (currentUrl.searchParams.has(key)) {
            url.searchParams.set(key, currentUrl.searchParams.get(key));
          }
        }

        const response = await fetch(url, { signal, credentials: 'same-origin' });
        if (!response.ok) return;
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = document.querySelector('[data-wf-certification-counts]');
        if (!source || signal.aborted || !this.isConnected) return;

        const keys = ['catalogue', 'kosher', 'halal'];
        const counts = Object.fromEntries(keys.map((key) => {
          const raw = source.dataset[key];
          const count = /^\d+$/.test(raw ?? '') ? Number(raw) : null;
          return [key, Number.isSafeInteger(count) ? count : null];
        }));
        if (counts.catalogue === null) return;

        for (const key of keys) {
          if (counts[key] === null || counts[key] > counts.catalogue) continue;
          const target = this.querySelector(`[data-count="${key}"]`);
          if (target) target.textContent = String(counts[key]);
        }
        this.dataset.countsReady = String(keys.every((key) => counts[key] !== null && counts[key] <= counts.catalogue));
      } catch {
        // The catalogue links and any server-rendered counts remain usable.
        // Never substitute estimates or zero for an unavailable count.
      } finally {
        window.clearTimeout(timeout);
        if (this.controller === controller) this.loading = false;
      }
    }
  }

  customElements.define('wf-home-certifications', WfHomeCertifications);
})();
